export const BUCKET_URL =
  process.env.NEXT_PUBLIC_SUPABASE_STORAGE_IMAGE_BUCKET_URL;
